import React, { useEffect, useState, useRef } from "react";

const Refund: React.FC = () => {
    return (
        <div
            className="container"
            style={{
                fontFamily: "Noto Sans",
            }}
        >
            <div>
                <h1
                    style={{
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    Refund Policy
                </h1>
                <p>
                    At ReThink Travel, we facilitate contributions towards
                    climate-focused initiatives, including but not limited to
                    carbon offsetting, tree planting, and green project funding.
                    All contributions made through our platform are considered
                    final, non-refundable, and non-reversible. By using our
                    services, you agree to the terms described herein. Please
                    ensure that you read this policy in full before proceeding
                    with any transaction on our platform.
                </p>
                <h1>No Refunds</h1>
                <p>
                    Once a contribution, funds transfer, donation, or payment
                    has been successfully processed and received by ReThink
                    Travel (including any associated service fees) or our
                    authorized partners, no refunds will be issued under any
                    circumstances. This policy applies regardless of the method
                    of payment, reason for request, or whether the user changes
                    their mind after initiating the transaction.
                </p>
                <p>
                    This includes but is not limited to:
                    <ul>
                        <li>Carbon offset payments</li>
                        <li>
                            Contributions toward tree planting or other green
                            projects
                        </li>
                        <li>Platform service fees</li>
                        <li>Donations or campaign contributions</li>
                        <li>
                            Payments made as part of event-based initiatives or
                            sustainability add-ons
                        </li>
                    </ul>
                </p>
                <h1>Confirmation of Intent</h1>
                <p>
                    By making a contribution on our platform, you confirm that:
                    <ul>
                        <li>
                            You understand and agree that the contribution is
                            voluntary and non-refundable.
                        </li>
                        <li>
                            You are not entitled to request a return or reversal
                            of funds once the transaction is complete.
                        </li>
                        <li>
                            You are contributing with the full understanding of
                            this Refund Policy.
                        </li>
                    </ul>
                </p>
                <h1>Event Partnerships</h1>
                <p>
                    ReThink Travel may collaborate with (including but not
                    limited to) event planners, hosts, or institutions to offer
                    sustainability-related services (such as carbon-neutral
                    weddings, return gifts, or group offsetting tools). All
                    contributions or purchases made in connection with such
                    partnerships are non-refundable, even in the event of:
                    <ul>
                        <li>Cancellation or rescheduling of the event</li>
                        <li>
                            Disagreement between event organizers and
                            participants
                        </li>
                        <li>Non-utilization of offset services post-event</li>
                    </ul>
                </p>
                <p>
                    Users and event participants are responsible for
                    understanding this policy prior to making payments or
                    contributions through the event campaign page or QR codes.
                </p>
                <h1>Subscription Plans (if introduced)</h1>
                <p>
                    Should ReThink Travel introduce a subscription-based model
                    in the future (e.g., monthly offsets, recurring donations,
                    sustainability services), users acknowledge and agree that:
                    <ul>
                        <li>
                            All subscription fees are non-refundable, regardless
                            of usage or cancellation timing.
                        </li>
                        <li>
                            Cancellation of a subscription will stop future
                            billing but will not result in any refund of past
                            payments.
                        </li>
                        <li>
                            ReThink Travel reserves the right to change,
                            suspend, or terminate subscription plans at any
                            time, without refund obligations.
                        </li>
                    </ul>
                </p>
                <h1>Third-Party Platforms</h1>
                <p>
                    In some cases, contributions may be facilitated through
                    third-party services or partners (e.g., payment gateways,
                    donation aggregators, or event platforms). Users are
                    responsible for understanding the terms of those third-party
                    platforms. However:
                    <ul>
                        <li>
                            Once funds are credited to ReThink Travel, directly
                            or via third parties, this Refund Policy will apply
                            in full.
                        </li>
                        <li>
                            ReThink Travel is not liable for any refund policies
                            of third parties, and will not process refunds on
                            their behalf.
                        </li>
                    </ul>
                </p>
                <h1>Exceptions</h1>
                <p>
                    There are no exceptions to this policy. ReThink Travel
                    reserves the right, at its sole discretion, to review refund
                    requests in the rare and exceptional cases. However, we are
                    under no obligation to approve such requests, and our
                    decision in these matters shall be final and binding.
                </p>
                <h1>Transfer of Funds</h1>
                <p>
                    Once the funds have been credited to ReThink Travel’s
                    account or to a third-party partner under our coordination,
                    the user shall have no claim, legal or otherwise, to recover
                    the amount contributed.
                </p>
                <h1>Disputes</h1>
                <p>
                    Initiating a chargeback or payment dispute in violation of
                    this Refund Policy may result in suspension or termination
                    of access to our services, and we reserve the right to
                    contest any such disputes with the relevant payment
                    processors or legal authorities. We reserve the right to
                    recover costs incurred during dispute resolution.
                </p>
                <h1>Policy Amendments</h1>
                <p>
                    ReThink Travel reserves the right to update or modify this
                    Refund Policy at any time, without prior notice. The latest
                    version will be published on our platform and will govern
                    all subsequent transactions.
                </p>
                <p>
                    If you have any questions about this Refund Policy, please
                    contact us at rethink@getre.org before making a payment.
                </p>
            </div>
        </div>
    );
};

export default Refund;
